export default __webpack_public_path__ + "static/favicon-512-1d7d1e09d1871a6611ef58e2ce63b9e3.png";